module.exports = __webpack_public_path__ + "img/whyluckperms-4.1cb67912.png";